import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-01/lesson-03/task-03";

const task: Slide = {
  titleHtml:
    "The wave at t=0 s is at x=0 m. Considering that this wave propagates to the right at<br>a speed of 340 m/s, where is the wave at t=0.1 s?",
  description: "Choose the right waveform.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
